
const deviceIcons = {
  Computer: 'icon-computer.svg',
  Tablet: 'icon-tablet.svg',
  SmartTV: 'icon-smart-tv.svg',
  PlayStation: 'icon-playstation.svg',
  AppleTV: 'icon-apple-tv.svg',
  Chromecast: 'icon-chromecast.svg',
  SmartPhone: 'icon-smartphone.svg',
  Carplay: 'icon-carplay.svg',
  Watch: 'icon-watch.svg',
  'Google home': 'icon-google-home.svg',
  Sonos: 'icon-sonos.svg'
}

export default {
  props: {
    playContent: {
      type: Object,
      default: () => {}
    }
  },
  setup () {
    return {
      deviceIcons
    }
  }
}
